 export const startTimer = () => ({
  type: "START_TIMER"
})

export const stopTimer = () => ({
  type: "STOP_TIMER"
}) 